import React, { useEffect } from 'react';
import { Link } from 'react-scroll';
import useDynamicRefs from 'use-dynamic-refs';

import { Wrapper, InnerWrapper } from './ScrollBar.style';

export default function TopBar({ menu = [], other, height, className }) {
  const [getRef, setRef] = useDynamicRefs();

  // Add all classs to an array
  const addAllClasses = ['scrollbar'];

  useEffect(() => {
    setTimeout(() => {
      // update the current position by click simulation
      // this is the workaround because scrollSpy from react-scroll doesn't support the offset
      if (window.location.hash) {
        const hashRef = getRef(window.location.hash.substring(1));
        if (hashRef && hashRef.current) {
          hashRef.current.click();
        }
      }
    }, 500);
  }, []);

  const handleclick = target => {
    window.location.hash = `#${target}`;
  };

  // className prop checking
  if (className) {
    addAllClasses.push(className);
  }

  return (
    <Wrapper className={addAllClasses.join(' ')} height={height}>
      <InnerWrapper>
        <div className='scrollbar_left'>
          {menu.map(menuItem => (
            <Link
              key={menuItem.target}
              onClick={e => handleclick(menuItem.target)}
              className='linkItem'
              activeClass='active'
              to={menuItem.target}
              spy={true}
              smooth={true}
              hashSpy={false}
              offset={-152}
              duration={500}
              isDynamic={true}
              ignoreCancelEvents={false}
            >
              <span ref={setRef(menuItem.target)}>{menuItem.name}</span>
            </Link>
          ))}
        </div>
        <div className='scrollbar_right'>{other && other}</div>
      </InnerWrapper>
    </Wrapper>
  );
}
